import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({})
export default class ApplyCouponInput extends Vue {
  @Action action_applyDiscountCode;
  @Action action_removeDiscountCode;

  @Getter getSubscription;
  @Getter getCity;

  inputValue = null;

  get isCouponApplied() {
    return this.getSubscription.coupon_code !== null && this.getSubscription.coupon_code !== "";
  }

  mounted() {
    this.onSubscriptionChange();
  }

  @Watch("getSubscription")
  onSubscriptionChange() {
    const { coupon_code } = this.getSubscription;
    this.inputValue = coupon_code;
  }

  async toggleAction() {
    try {
      const payload = {
        commerceId: this.getCity.id,
        subscriptionId: this.getSubscription.id,
        code: { code: this.inputValue },
      };
      this.$emit("set-loading", true);
      if (!this.isCouponApplied) {
        await this.action_applyDiscountCode(payload);
      } else {
        await this.action_removeDiscountCode(payload);
        this.inputValue = null;
      }
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Error al actualizar cupón. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
    this.$emit("set-loading", false);
  }
}
